<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${customer.short_name}`">
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Customer Actions">
          <b-button variant="success" class="ml-1 text-white" to="/customer"
            ><i class="fal fa-list" />
          </b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>
    <br />
    <permission-alert-gate :permissions="'edit customer'">
      <template #gated-content>
        <customer-form :customer="customer" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import CustomerForm from "@/components/crm/customer/form/CustomerForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { getModel } from "@/shared/fetch-utils";
import { CrmRepositoryFactory } from "@/repositories/crm/CrmRepositoryFactory";
import { customerNotifications } from "@/shared/notifications";
import { notificationOptions } from "@/shared/toast-notification-options";

const CustomerRepository = CrmRepositoryFactory.get("customers");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "CustomerEdit",
  mixins: [ToastNotifications],
  components: {
    BasicHeading,
    CustomerForm,
    PermissionAlertGate,
  },
  props: {},
  data() {
    return {
      loading: true,
      customer: null,
      customer_id: this.$route.params.customer_id || null,
    };
  },
  methods: {
    async submit(form_data) {
      try {
        await CustomerRepository.update(this.customer_id, form_data);

        this.editSuccess();
        this.$router.push(`/customer/${this.customer_id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.customer = await getModel({
      model_type: "customer",
      id: this.customer_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: customerNotifications,
};
</script>
